import "@fontsource/righteous";

const Fonts = {
  righteous: "righteous"
}

export default Fonts;